// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import VueVideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
Vue.use(VueVideoPlayer);
import 'babel-polyfill'
// import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import App from './App'
import router from './router/index'
import store from './store/index'
//导入网络请求

import axios from './axios/index'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
Vue.use(YDUI);
import $ from 'jquery'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
// import '../src/assets/common.css'
Vue.use(VueAwesomeSwiper);

// import infiniteScroll from 'vue-infinite-scroll'
// Vue.use(infiniteScroll)
// import Croppa from 'vue-croppa'
// import "vue-croppa/dist/vue-croppa.css";
// Vue.use(Croppa)

// import preloadImage from 'vue-preload-image'
// Vue.component('preload-image', preloadImage)


Vue.prototype.jump=function(path,arg){
  var obj={};
  obj={path:path,query:arg}
  this.$router.push(obj)
}
Vue.config.productionTip = false
//发布后是否显示提示
Vue.config.productionTip = false

//是否开启工具调试
Vue.config.devtools = process.env.NODE_ENV === 'development'

/* eslint-disable no-new */
new Vue({
  el: '#app',

  router,
  store,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js


// WEBPACK FOOTER //
// ./src/main.js